import queryString from 'query-string';
function parseUrlParams(query) {
  return queryString.parse(query, {
    arrayFormat: 'bracket'
  });
}
function stringifyUrlParams(params) {
  return queryString.stringify(params, {
    arrayFormat: 'bracket'
  });
}
export function createUrlWithQuery(url = '', query) {
  const urlWithQuery = new URL(url);
  if (typeof query === 'object' && query !== null) {
    urlWithQuery.search = stringifyUrlParams({
      ...parseUrlParams(urlWithQuery.search),
      ...query
    });
  }
  return urlWithQuery;
}
function isObject(value) {
  return value !== null && typeof value === 'object';
}
export function isDeferredJobResponse(value) {
  return isObject(value) && typeof value.status === 'string' && isObject(value.progress) && typeof value.progress.id === 'string' && Array.isArray(value.progress.links) && value.progress.links.every(link => typeof link === 'string');
}